import {
  Add,
  Cable,
  CallMadeOutlined,
  CallReceivedOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  ListItem,
  ListItemContent,
  ListItemDecorator,
  Stack,
  Typography
} from "@mui/joy";

import * as React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router";
import { CryptoCurrencyFormat, CurrencyFormat } from "../config/services";

export default function HomeIndex() {
  const navigate = useNavigate();
  const userinfo = useSelector((state) => state.useInfos);
  const walletData = useSelector((state) => state.walletsData);
  const [showbalance, setSahowbalance] = React.useState(true);

  return (
    <Grid container direction="column" spacing={2} sx={{ flexGrow: 1 }} mt={1}>
      <Grid>
        <Card variant="solid" color="primary" invertedColors>
          <CardContent>
            <Stack direction="column" spacing={1} alignItems={"flex-start"}>
              <Stack direction="column" spacing={0}>
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <Typography level="title-sm">Available balance</Typography>
                  <IconButton
                    size="sm"
                    variant="plain"
                    color="neutral"
                    onClick={() => setSahowbalance(!showbalance)}
                  >
                    {showbalance ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </Stack>

                <Typography level="h1">
                  {showbalance ? (
                    <CurrencyFormat
                      amount={userinfo.totalBalance}
                      prefix={"$"}
                      seperator={true}
                    />
                  ) : (
                    "* * * *"
                  )}
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Grid>

      <Grid mt={2}>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          {[
            {
              title: "Send",
              path: "/allcoin",
              icon: <CallMadeOutlined fontSize="xl2" />,
            },
            {
              title: "Receive",
              path: "/receive",
              icon: <CallReceivedOutlined fontSize="xl2" />,
            },
            { title: "Buy", path: "/buy", icon: <Add fontSize="xl2" /> },
            {
              title: "Connect",
              path: "/connect",
              icon: <Cable fontSize="xl2" />,
            },
          ].map((button, index) => (
            <Stack
              key={index}
              direction="column"
              spacing={1}
              alignItems="center"
            >
              <IconButton
                key={button.title}
                variant="solid"
                size="lg"
                color="primary"
                sx={{ width: "50px", height: "50px", borderRadius: "50px" }}
                onClick={() => navigate(button.path)}
              >
                {button.icon}
              </IconButton>
              <Typography>{button.title}</Typography>
            </Stack>
          ))}
        </Box>
      </Grid>

      <Grid mt={2}>
        <Stack direction="column" spacing={2}>
          {walletData.map((coin, index) => (
            <Link
              to={"/coin"}
              state={{ coin: coin }}
              style={{ textDecoration: "none" }}
              key={index}
            >
              <Card onClick={() => console.log("olll")} variant="outlined">
                <ListItem>
                  <ListItemDecorator>
                    <Badge
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      variant="plain"
                      badgeContent={
                        <Avatar
                          variant="plain"
                          alt="Remy Sharp"
                          src={coin.thumbimage}
                          sx={{ "--Avatar-size": "16px" }}
                        />
                      }
                      badgeInset="14%"
                      sx={{ "--Badge-paddingX": "0px" }}
                      slotProps={{ badge: { style: { boxShadow: "none" } } }}
                    >
                      <Avatar src={coin.image} size="md" />
                    </Badge>
                  </ListItemDecorator>

                  <ListItemContent>
                    <Stack direction="column" spacing={1} ml={2}>
                      <Typography level="body-lg">{coin.code}</Typography>

                      <Typography level="title-sm">
                        <CurrencyFormat
                          amount={coin.price}
                          prefix="$"
                          seperator={true}
                        />{" "}
                        <font
                          color={
                            coin.difference < 0 ? "orangered" : "springgreen"
                          }
                        >
                          {coin.difference.toFixed(2)}%
                        </font>
                      </Typography>
                    </Stack>
                  </ListItemContent>
                  <Stack direction="column" spacing={1} alignItems="end">
                    <Typography level="title-md">
                      {coin.balancecoin == 0 ? (
                        `0.00`
                      ) : (
                        <CryptoCurrencyFormat
                          amount={coin.balancecoin}
                          // suffix={` ${coin.code}`}
                        />
                      )}
                    </Typography>
                    <Typography level="title-sm">
                      <CurrencyFormat
                        amount={coin.balance}
                        prefix="$"
                        seperator={true}
                      />
                    </Typography>
                  </Stack>
                </ListItem>
              </Card>
            </Link>
          ))}
        </Stack>
      </Grid>
    </Grid>
  );
}
